import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions } from "@headlessui/react";
import { ExclamationCircleIcon } from '@heroicons/react/16/solid';
import { CheckIcon, ChevronUpDownIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { MapPinIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { classNames } from "../../helpers";
import { loadingState } from "../../redux/reducers/loadingReducer";

export default function TwAutocomplete(props) {
  const loadingReduxState = useSelector(loadingState);

  const { variant = "default", name = "", label = "", className = "", errors = {}, error = "", leftIcon = "", rightIcon = "" } = props
  let inputProps = { ...props }
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  delete inputProps.defaultLocationSelect
  delete inputProps.options
  delete inputProps.optionView
  let inputLableClass = "text-black/[0.6]"
  let inputClass = "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
  }

  if (inputProps.disabled && inputProps.disabled !== undefined) {
    inputClass += " bg-gray-200 disabled:bg-gray-200"
  }

  const [query, setQuery] = useState('')
  const [optionData, setOptionData] = useState({});
  const [options, setOptions] = useState([]);

  React.useEffect(() => {
    if (props.defaultValue) {
      setOptionData(props.defaultValue);
    }
  }, [props.defaultValue]);
  React.useEffect(() => {

    if (props.options && Array.isArray(props.options)) {
      if (props.isAsync !== undefined && props.isAsync == true) {
        setOptions(props.options);
      } else {
        setOptions(props.options.filter((option) => {
          return query !== "" ? option.label.toLowerCase().includes(query.toLowerCase()) : true
        }));

      }
    }
  }, [props.options]);

  React.useEffect(() => {
    if (query != undefined && props.onQueryChange != undefined) {
      props.onQueryChange(query)
    }
  }, [query]);

  return (
    // <div className="">
    <div className="w-full sm:w-full sm:max-w-sm md:max-w-lg">
      {label && (<label htmlFor={name} className={classNames("block text-sm/6 font-medium", inputLableClass)}>
        {label}
      </label>)}
      <div className="">
        <Combobox
          as="div"
          value={optionData}
          className={classNames("rounded-xl [bg-input-bz] px-2 py-1 outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 ",
            variant === "input" ? "bg-input-bz" : "",
            inputClass)}
          onChange={(e) => {
            // setQuery(e?.target?.value || e?.label || "")
            setQuery("")
            if (e?.label) {
              setOptionData(e)
              props.onChange(e)
            } else {
              setOptionData({})
              props.onChange({})
            }
          }}
        >
          <div className="relative rounded-lg pr-6">

            {leftIcon && (
              <ComboboxButton className="absolute inset-y-0 left-0 flex items-center rounded-l-md px-2 md:px-3 focus:outline-none">{leftIcon}</ComboboxButton>
            )}
            <ComboboxInput
              {...inputProps}
              className={classNames("bg-transparent w-full min-w-0 grow py-2 md:py-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6",
                props.error ? "pr-6" : "pr-3",
                leftIcon ? "pl-4" : "pl-3"
              )}
              placeholder={props.placeholder || "Search..."}
              displayValue={(value) => value && (value.label || value?.optionData)}
              onChange={(event) => {
                setQuery(event?.target?.value || "")
              }}
              onBlur={() => setQuery('')}
            />
            {optionData?.label && optionData?.label !== "" && (<ComboboxButton
              className="absolute inset-y-0 right-5 flex items-center rounded-r-md px-0 focus:outline-none"
              onClick={(e) => { setQuery(""); setOptionData({}); props.onChange({}) }}
            >
              <XMarkIcon className="size-5 text-gray-400" aria-hidden="true" />
            </ComboboxButton>)}
            <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-0 focus:outline-none">
              <ChevronUpDownIcon className="size-5 text-gray-400" aria-hidden="true" />
            </ComboboxButton>
            {(<ComboboxOptions
              className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
            >
              {options.length > 0 &&
                options.map((option, idx) => {
                  return (
                    <ComboboxOption
                      className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 focus:bg-indigo-600 focus:text-white focus:outline-none"
                      key={idx}
                      value={option}
                    >
                      {props.optionView != undefined ? props.optionView(option.data) : (
                        <>
                          <div className="flex items-center">

                            <span className="ml-3 truncate group-data-[selected]:font-semibold">
                              {option.label}
                            </span>
                          </div>
                          <span className={classNames("absolute inset-y-0 right-0  items-center pr-4 text-indigo-600 group-focus:text-white",
                            option.label === query ? "flex" : "hidden"
                          )}>
                            <CheckIcon className="size-5" aria-hidden="true" />
                          </span>
                        </>
                      )}

                    </ComboboxOption>
                  );
                })}
            </ComboboxOptions>)}
            {props.error && (<ComboboxButton className="absolute inset-y-0 right-5 flex items-center rounded-r-md px-2 focus:outline-none">
              <ExclamationCircleIcon
                aria-hidden="true"
                className="pointer-events-none col-start-1 row-start-1 size-5 self-center justify-self-end text-red-500 sm:size-4"
              />
            </ComboboxButton>)}
          </div>
        </Combobox>
      </div>
      {props.error && (<p id="email-error" className="mt-2 text-sm text-red-600">
        {props.error}
      </p>)}
    </div>
  );
}
